import { useAtom, useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import {
  checkedListAtom,
  filterValuesAtom,
  isCheckAllAtom,
  orderByAtom,
  paginationConfigAtom,
} from './EPList/state';
import { epTypeAtom, appliedEPIdsAtom } from '../EPDashboard/state';

export function useOnCompanyChangeEpResetAtoms() {
  const resetSelectedHostIds = useResetAtom(appliedEPIdsAtom);
  const resetHostTypeAtom = useResetAtom(epTypeAtom);
  const resetOrderbyAtom = useResetAtom(orderByAtom);
  const resetCheckedListAtom = useResetAtom(checkedListAtom);
  const resetIsCheckAllAtom = useResetAtom(isCheckAllAtom);
  const resetFilterValuesAtom = useResetAtom(filterValuesAtom);
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const resetAtoms = () => {
    resetSelectedHostIds();
    resetHostTypeAtom();
    resetOrderbyAtom();
    resetCheckedListAtom();
    resetIsCheckAllAtom();
    // Only reset page number, preserve page size
    setPaginationConfig({
      ...paginationConfig,
      page: 1,
    });
    resetFilterValuesAtom();
  };
  return resetAtoms;
}

export const useEPListFilterValue = <T = string,>(
  key: string,
  defaultValue: T = '' as unknown as T,
): T => {
  const filterValues = useAtomValue(filterValuesAtom);
  return (filterValues?.[key]?.[0] ?? defaultValue) as T;
};
